<jha-function-view
  [jhaIsBusy]="sending"
  jhaTitle="Change Password"
  jhaBackgroundImageUrl="assets/images/JHAMobileCreditCard.jpg">
  <jha-inline-notification
    *ngIf="passwordChanged"
    jhaType="Success"
    [jhaIsClosable]="true"
    jhaIconType="Success">
    Your password was successfully changed.
  </jha-inline-notification>

  <jha-inline-notification
    jhaType="Error"
    jhaIconType="Error"
    [jhaIsClosable]="true"
    *ngIf="serviceError">
    {{ serviceErrorMessage }}
  </jha-inline-notification>

  <jha-display-block *ngIf="!passwordChanged">
    <jha-caps-lock-warning></jha-caps-lock-warning>

    <div class="row">
      <div class="col-md-6">
        <form
          role="form"
          [formGroup]="changePasswordForm"
          (ngSubmit)="changePassword()">
          <div class="form-group">
            <div>
              <label
                class="control-label jha-required-indicator"
                for="CurrentPassword"
                >User Id:</label
              >
            </div>

            <div>
              <input
                class="form-control"
                id="email"
                formControlName="email"
                type="email"
                class="form-control" />
            </div>
          </div>

          <div
            class="form-group"
            [ngClass]="{
              'has-error':
                newPassword.invalid &&
                (newPassword.dirty || newPassword.touched)
            }">
            <div>
              <label
                class="control-label jha-required-indicator"
                for="NewPassword"
                >New Password:</label
              >
            </div>

            <div>
              <input
                id="NewPassword"
                attr.type="{{ showPasswords ? 'text' : 'password' }}"
                class="form-control"
                formControlName="newPassword"
                required
                autocomplete="off"
                maxlength="100"
                autocorrect="off"
                autocapitalize="off"
                spellcheck="false"
                (blur)="setPasswordStrength()" />

              <!-- Password strength meter: display after user has left the New Password input -->

              <jha-password-strength-meter
                *ngIf="passwordStrengthValue > 0"
                [jhaStrengthValue]="passwordStrengthValue"
                [jhaStrengthDescription]="passwordStrengthDescription">
              </jha-password-strength-meter>

              <div
                *ngIf="
                  newPassword.invalid &&
                  (newPassword.dirty || newPassword.touched)
                "
                class="help-block">
                <div *ngIf="newPassword.errors['required']">
                  New Password is required
                </div>

                <div *ngIf="newPassword.errors['passwordTooShort']">
                  Must be at least 8 characters
                </div>

                <div *ngIf="newPassword.errors['passwordNoUppercase']">
                  Must have at least 1 uppercase character
                </div>

                <div *ngIf="newPassword.errors['passwordNoLowercase']">
                  Must have at least 1 lowercase character
                </div>

                <div *ngIf="newPassword.errors['passwordNoSymbol']">
                  Must have at least 1
                  <a (click)="showSymbolCharacters = true">symbol character</a>
                </div>

                <div *ngIf="newPassword.errors['passwordNoNumber']">
                  Must have at least 1 number
                </div>
              </div>
            </div>
          </div>

          <div
            class="form-group"
            [ngClass]="{
              'has-error':
                (newPasswordRepeated.invalid ||
                  changePasswordForm.errors?.passwordMismatch) &&
                (newPasswordRepeated.dirty || newPasswordRepeated.touched)
            }">
            <div>
              <label
                class="control-label jha-required-indicator"
                for="NewPasswordRepeated"
                >Confirm New Password:</label
              >
            </div>

            <div>
              <input
                id="NewPasswordRepeated"
                attr.type="{{ showPasswords ? 'text' : 'password' }}"
                class="form-control"
                formControlName="newPasswordRepeated"
                required
                autocomplete="off"
                autocorrect="off"
                autocapitalize="off"
                spellcheck="false" />

              <div
                *ngIf="
                  newPasswordRepeated.invalid &&
                  (newPasswordRepeated.dirty || newPasswordRepeated.touched)
                "
                class="help-block">
                <div *ngIf="newPasswordRepeated.errors['required']">
                  Confirm New Password is required
                </div>
              </div>

              <!-- This is a form-level validation since it compares two fields. We typically display form-level validation errors

                                 above the form, but in this particular case we display it here since the error message applies more to this field -->

              <div
                *ngIf="
                  changePasswordForm.errors &&
                  (newPasswordRepeated.dirty || newPasswordRepeated.touched)
                "
                class="help-block">
                <div *ngIf="changePasswordForm.errors['passwordMismatch']">
                  Does not match the new password value
                </div>
              </div>
            </div>
          </div>

          <div class="form-group submit-row">
            <div class="submit-button">
              <jha-button
                id="changePasswordButtonSubmit"
                jhaText="Change Password"
                jhaButtonStyle="Primary"
                [jhaIsDisabled]="!changePasswordForm.valid"
                jhaButtonType="submit"></jha-button>
            </div>

            <div class="show-password">
              <jha-toggle
                id="ShowPasswords"
                [(jhaToggleVal)]="showPasswords"
                class="show-password-toggle"></jha-toggle>

              <label class="control-label" for="ShowPasswords"
                >Show Passwords</label
              >
            </div>
          </div>
        </form>
      </div>

      <!-- Spacer column -->

      <div class="col-md-1"></div>

      <!-- List of password requirements-->

      <div class="col-md-5">
        <jha-subheader jhaText="Password Requirements"></jha-subheader>

        <ul class="requirement-list">
          <li>Must be at least 8 characters (max 100)</li>

          <li>Must not have spaces</li>

          <li>Must have at least 1 uppercase character</li>

          <li>Must have at least 1 lowercase character</li>

          <li>Must have at least 1 number</li>

          <li>
            Must have at least 1
            <a (click)="showSymbolCharacters = true">symbol character</a>
          </li>
        </ul>
      </div>
    </div>
  </jha-display-block>

  <!-- DIalog box that displays a table with all symbol characters -->

  <app-symbol-rules [(showDialog)]="showSymbolCharacters"></app-symbol-rules>
</jha-function-view>
